<template>
	<div class="data-table-container customize-table">
		<v3-table :headers="headers" :items="itemsToDisplay" alternating :rows-per-page="rowsPerPage" hide-rows-per-page
			hide-footer>
			<template #expand="{ skills, agentDocument }">
				<div class="d-flex ml-10 align-center">
					<div class="mr-4 text-subtitle-2">{{ $t('skillset') }}</div>
					<div>
						<v-chip v-for="skill in skills" class="ml-2" size="small" :key="skill.id" :style="{
							'background-color': colorGenerator(skill.name),
						}">
							<span style="color: #fff; font-weight: 500">
								{{ skill.name }}
							</span>
						</v-chip>
					</div>
				</div>

				<div class="d-flex ml-10 mt-3 align-center">
					<div class="mr-4 text-subtitle-2">{{ $t('certificate') }}</div>
					<div class="font-weight-medium">
						{{ agentDocument.length }}

						<span v-if="agentDocument.length > 1">Files</span>
						<span v-else>File</span>
					</div>
				</div>
			</template>
			<template #header-updatedAt="header">
				<div class="text-left cursor-pointer" @click="sortDate">
					{{ $t('date_and_time') }}
				</div>
			</template>
			<template #header-agentDetial="header">
				<div class="text-left cursor-pointer">
					{{ $t('agent_name') }}
				</div>
			</template>
			<template #header-email="header">
				<div class="text-left cursor-pointer">
					{{ $t('email') }}
				</div>
			</template>
			<template #header-phone="header">
				<div class="text-left cursor-pointer">
					{{ $t('phone') }}
				</div>
			</template>
			<template #header-type="header">
				<div class="text-left cursor-pointer">
					{{ $t('type') }}
				</div>
			</template>
			<template #item-buttons="{ id, approved, pendingApproval }">
				<div v-if="!pendingApproval && !approved">
					<v-btn class="px-5 ml-10 rounded-xl bg-yellow-darken-3" size="small" elevation="0"
						@click="reapproveAgent(id)">
						{{ $t('reapprove') }}
					</v-btn>
				</div>
				<div v-else>
					<v-btn class="px-5 rounded-xl" style="background-color: rgba(211, 249, 220, 1)"
						@click="approveAgent(id)" size="small" elevation="0">
						{{ $t('approve') }}
					</v-btn>
					<v-btn class="px-5 ml-2 rounded-xl" style="background-color: rgba(255, 194, 198, 1)"
						@click="rejectAgent(id)" size="small" elevation="0">
						{{ $t('decline') }}
					</v-btn>
				</div>
			</template>
			<template #item-icon="{ id }">
				<div>
					<v-icon style="
							color: grey;
							padding-right: 10px;
							cursor: pointer;
						">mdi-pencil</v-icon>
				</div>
			</template>
			<template #item-activeStatus="{ active }">
				<v-chip :class="active ? 'active-status' : 'inactive-status'" density="default"><v-icon start
						icon="mdi-circle" :class="active
							? 'active-status-icon'
							: 'inactive-status-icon'
							"></v-icon>{{ active ? 'Active' : 'Inactive' }}
				</v-chip>
			</template>
			<template #item-agentDetial="{ id, lineName, firstName, lastName }">
				<p style="font-weight: bold" @click="editAgent(id)">
					{{ $t('line_name') }} : {{ lineName }}
				</p>
				<p style="font-size: 0.9rem">{{ firstName }} {{ lastName }}</p>
			</template>

			<template #item-updatedAt="{ updatedAt }">
				<p>{{ formatDate(updatedAt) }}</p>
			</template>
			<template #item-type="{ UserRoles }">
				<p style="font-weight: bold; margin-bottom: 1px">
					{{ UserRoles[0]?.UserRole?.type === 'general' ? 'IT Service' : UserRoles[0]?.UserRole?.type ===
						'esg' ? 'ESG' : '' }}
				</p>
			</template>

		</v3-table>

		<div class="d-flex flex-row-reverse mx-10">
			<div class="d-flex">
				<div class="my-auto">{{ $t('rows_per_page') }}:</div>
				<v-select variant="underlined" :items="[10, 25, 50, 100]" style="max-width: 4.5rem" class="ml-8 my-auto"
					v-model="totalRowsPerPage" @update:model-value="onClick(totalRowsPerPage)"></v-select>
				<div class="my-auto ml-10">
					{{
						this.initialPage == 1
							? this.initialPage
							: (this.initialPage - 1) * this.totalRowsPerPage + 1
					}}
					- {{ this.initialPage * this.totalRowsPerPage }} of
					{{ this.totalIncidents }}
				</div>
				<div class="my-auto">
					<v-btn :disabled="initialPage == 1" variant="text" @click="previousPage">
						<v-icon size="30">mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn :disabled="items.length < this.totalRowsPerPage" variant="text" @click="nextPage">
						<v-icon size="30">mdi-chevron-right</v-icon>
					</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import settings from '@/services/API/settings'

export default {
	async created() {

		await settings.getDefaultPageValue().then((response) => {

			this.totalRowsPerPage = response.data.pageSize
		})
	},
	name: 'DataTable',
	components: {
		'v3-table': Vue3EasyDataTable,
	},
	props: {
		headers: Array,
		items: Array,
		rowsPerPage: {
			type: Number,
			default: 100,
		},
	},
	emits: [
		'showAgent',
		'openAgentEditor',
		'approveAgent',
		'rejectAgent',
		'reapproveAgent',
		'totalRowsPerPage',
		'pageNumber',
	],
	methods: {
		previousPage() {
			this.initialPage -= 1

			this.$emit('pageNumber', this.initialPage)
		},
		nextPage() {
			this.initialPage += 1

			this.$emit('pageNumber', this.initialPage)
		},
		onClick(length) {

			this.$emit('totalRowsPerPage', length)
		},
		formatDate(dateString) {
			return moment(dateString).format('DD/MM/Y hh:mm ')
		},
		editAgent(id) {
			this.$emit('openAgentEditor', id)
		},
		reapproveAgent(id) {
			this.$emit('reapproveAgent', id)
		},
		approveAgent(id) {
			this.$emit('approveAgent', id)

		},
		rejectAgent(id) {
			this.$emit('rejectAgent', id)

		},
		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)

			return `#${hex}`
		},
		updateCurrentPage(page) {
			this.currentPage = page
		},
	},
	data: () => ({
		totalRowsPerPage: '10',
		openCreateDialog: false,
		currentPage: 1,
		colorCode: {
			low: 'gray',
			normal: 'green',
			high: 'yellow',
			urgent: 'red',
		},
		agentDetials: {},
		itemSelected: [],
		initialPage: 1,
		initialRowsPerPage: '10',
		totalIncidents: '100',
	}),
	computed: {
		itemsToDisplay() {
			// Reverse the array to display the latest items at the top
			const reversedItems = [...this.items].reverse()

			const startIndex = (this.currentPage - 1) * this.rowsPerPage
			const endIndex = startIndex + this.rowsPerPage

			// Slice the reversed array
			return reversedItems.slice(startIndex, endIndex)
		},
	},
}
</script>
<style scoped>
.customize-table {
	--easy-table-border: 1px solid var(--primary-color-lighten);
	--easy-table-row-border: 1px solid var(--primary-color-lighten);
	--easy-table-header-font-size: 18px;
	--easy-table-header-height: 50px;
	--easy-table-header-background-color: var(--secondary-color);
	--easy-table-header-item-padding: 15px 20px;
	/* --easy-table-header-font-color: white; */

	--easy-table-body-row-background-color: var(--secondary-color-lighten);
	--easy-table-body-row-height: 50px;
	--easy-table-body-row-font-size: 16px;
	--easy-table-body-row-hover-background-color: var(--primary-color-lighten);

	--easy-table-body-item-padding: 10px 15px;
	--easy-table-footer-background-color: var(--gray-1);
	--easy-table-footer-font-size: 14px;
	--easy-table-footer-padding: 0px 10px;
	--easy-table-footer-height: 50px;

	--easy-table-loading-mask-background-color: #000000;
	font-family: 'Roboto';
}

.active-status {
	background-color: #d3f9dc;
	color: green;
	padding: 10px;
	width: 100px;
	/* margin-align: auto; */
	display: flex;
	justify-content: center;
	font-weight: bold;

	/* border-radius: 10px; */
}

.active-status-icon {
	color: green;
}

.inactive-status-icon {
	color: rgb(172, 44, 44);
}

.inactive-status {
	background-color: #f09d70;
	color: rgb(172, 44, 44);
	padding: 10px;
	width: 100px;
	text-align: center;
	display: flex;
	justify-content: center;
	font-weight: bold;
	/* border-radius: 10px; */
}

.link {
	font-weight: 500;
	cursor: pointer;
}
</style>
